import { render } from "./hospitalisations_tab.vue?vue&type=template&id=c1a97cf8"
import script from "./hospitalisations_tab.vue?vue&type=script&lang=js"
export * from "./hospitalisations_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__